import { Stack, Typography } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { DealFlowStateTag } from "components/ui/atoms/Tag";
import { useDealFlowCompanyStates } from "models/companies/apiCompany";

const DealFlowCompanyStateItem = ({ dealFlowCompanyState }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography
        variant="subtitle2"
        sx={{ minWidth: { xs: 150, md: "auto" } }}
        mr={0.5}
      >
        {dealFlowCompanyState.deal_flow_detail.short_name}
      </Typography>
      <DealFlowStateTag dealFlowCompanyState={dealFlowCompanyState} />
    </Stack>
  );
};

const DealFlowCompanyState = ({ companyId }) => {
  const {
    data: dealFlowCompanyStates,
    isLoading,
    isError,
  } = useDealFlowCompanyStates(companyId);

  if (isError) return <>Error</>;

  return (
    <Stack direction="column" spacing={1} px={2}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
      >
        {isLoading ? (
          <Skeleton variant="rectangular" height={60} width="100%" />
        ) : (
          dealFlowCompanyStates.map((dealFlowCompanyState) => {
            return (
              <DealFlowCompanyStateItem
                key={dealFlowCompanyState.id}
                dealFlowCompanyState={dealFlowCompanyState}
              />
            );
          })
        )}
      </Stack>
    </Stack>
  );
};

export default DealFlowCompanyState;
